import { Injectable } from '@angular/core'
import { AjaxService } from 'src/app/shared/ajax.service'
import { TreeviModel } from '../treev.model'

@Injectable({
  providedIn: 'root'
})
export class TreeviService {

  constructor(private ajax: AjaxService) { }

  load(model: TreeviModel) {
    let data = { id: '2020042214524708499' }
    this.ajax.execute({
      url: 'treev/load',
      data: data,
      success: (post: any) => {
        let dats = post.result
      }
    })
  }
}